import FilledButton from "../../../component/FilledButton";
import { Form } from "antd";
import { useEffect, useState } from "react";
import { ReactComponent as DropArrow } from '../../../assets/images/drop_arrow.svg';
import { Select } from "antd";

const SearchPop = ({ search, setSearch, setModalOpen, filteredPosts }) => {
    const [form] = Form.useForm();
    const [ownerType] = useState(['All', 'Admin', 'Community Manager'])

    useEffect(() => {
        form.resetFields()
    }, [filteredPosts])

    return (
        <div className="modal_body">
            <Form
                form={form}
                name="register"
                onFinish={(e) => { setSearch({ ...search, isSearch: true }); setModalOpen(false); }}
                onReset={() => { setModalOpen(false); setSearch({ title: '', owner: 'All', isSearch: false }) }}
                initialValues={search}
                className="attached_courses-add_skill search_modal"
            >
                <h2>Search Group</h2>
                <Form.Item name="title" className="form_group">
                    <label>Group Name</label>
                    <input name="name" value={search.title} onChange={(e) => setSearch({ ...search, title: e.target.value })} type="text" className="form_control" autoComplete='off' autoFocus />
                </Form.Item>
                <Form.Item name="owner" className="form_group">
                    <label htmlFor="">Group Owner</label>
                    <div className="form_input">
                        <Select placeholder={"Select from below"} value={search.owner} onChange={(e) => setSearch({ ...search, owner: e })} suffixIcon={<DropArrow />} type="dropdown" className="form_control skill_multiselect" >
                            {
                                ownerType.map(option => (
                                    <option key={option} value={option}>{option}</option>
                                ))
                            }
                        </Select>
                    </div>
                </Form.Item>
                <div className="form_group form_footer">
                    <FilledButton type="reset" className="btn btn_gray" value="Cancel" />
                    <FilledButton type="submit" className="btn btn_primary" value="Search" />
                </div>
            </Form>
        </div>
    )
};

export default SearchPop;